import { useEffect, useState, useCallback, memo } from "react";

import classes from "./SelectIngredients.module.css";

import IngredientBarBasic from "../IngredientBarBasic/IngredientBarBasic";
import SearchIngredientsBar from "../SearchIngredientsBar/SearchIngredientsBar";

import { useIngredients } from "../../../store/IngredientContext";

// component allows users to select ingredients to query the backend with to find cocktails
const SelectIngredients = (props) => {
  const [ingredientSearchResults, setIngredientSearchResults] = useState([]);
  const [showAlcoholIngredients, setShowAlcoholIngredients] = useState(false);
  const [showMixerIngredients, setShowMixerIngredients] = useState(false);
  const [showIngredientSearchForm, setShowIngredientSearchForm] =
    useState(false);
  const { loadedIngredients } = useIngredients();

  // handler to expand list of alcoholic ingredients
  const showAlcoholIngredientsHandler = () => {
    setShowAlcoholIngredients(!showAlcoholIngredients);
  };

  // handler to expand list of non-alcoholic ingredients
  const showMixerIngredientsHandler = () => {
    setShowMixerIngredients(!showMixerIngredients);
  };

  // handler to expand ingredient search fundtion, not to be confused with the separe overall cocktail search using the ingredients
  const showIngredientSearchFormHandler = () => {
    setShowIngredientSearchForm(!showIngredientSearchForm);
  };

  // function to search for ingredient by name
  const searchResultsHandler = useCallback(
    (searchValue) => {
      var results = [];
      loadedIngredients.forEach((ing) => {
        if (ing.title.toLowerCase().includes(searchValue.toLowerCase())) {
          results.push(ing);
        }
      });
      setIngredientSearchResults(results);
    },
    [loadedIngredients]
  );

  // map resulting ingredients from ingredient search to bars
  const resultsBars = ingredientSearchResults.map((ing) => {
    return <IngredientBarBasic key={ing._id} ingredient={ing} />;
  });

  const clearSearchHandler = () => {
    setIngredientSearchResults([]);
  };

  // order ingredients into alcoholic and non-alcoholic (mixers) lists
  let alcoholicIngredients;
  let mixerIngredients;

  if (loadedIngredients) {
    var alcohols = [];
    var mixers = [];

    for (var ing of loadedIngredients) {
      if (ing.type_1 === "alcohol") alcohols.push(ing);
      if (ing.type_1 === "mixer") mixers.push(ing);
    }

    alcoholicIngredients = alcohols.map((ingredient) => {
      return (
        <IngredientBarBasic key={ingredient._id} ingredient={ingredient} />
      );
    });

    mixerIngredients = mixers.map((ingredient) => {
      return (
        <IngredientBarBasic key={ingredient._id} ingredient={ingredient} />
      );
    });
  }

  return (
    <div className={classes.select_ingredients}>
      <div className={classes.ingredients_list}>
        <div
          className={classes.ingredient_list_header}
          onClick={showIngredientSearchFormHandler}
        >
          {!showIngredientSearchForm ? "Search >>" : "Search <<"}
        </div>
        {showIngredientSearchForm && (
          <SearchIngredientsBar
            searchHandler={searchResultsHandler}
            clearSearch={clearSearchHandler}
          />
        )}
        {resultsBars}
      </div>

      <div className={classes.ingredients_list}>
        <div
          className={classes.ingredient_list_header}
          onClick={showAlcoholIngredientsHandler}
        >
          {!showAlcoholIngredients ? "Alcohol >>" : "Alcohol <<"}
        </div>
        {showAlcoholIngredients && alcoholicIngredients}
      </div>

      <div className={classes.ingredients_list}>
        <div
          className={classes.ingredient_list_header}
          onClick={showMixerIngredientsHandler}
        >
          {!showMixerIngredients ? "Mixers >>" : "Mixers <<"}
        </div>
        {showMixerIngredients && mixerIngredients}
      </div>
    </div>
  );
};

export default memo(SelectIngredients);
